import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.syncSelection()
  }

  selectColor(event) {
    event.preventDefault()
    const color = event.params.value
    if (this.hasInputTarget && color) {
      this.inputTarget.value = color
    }
    this.markSelected(event.currentTarget)
  }

  syncSelection() {
    if (!this.hasInputTarget) return
    const current = this.inputTarget.value
    const match = this.element.querySelector(`[data-color-picker-value-param="${current}"]`)
    if (match) {
      this.markSelected(match)
    }
  }

  markSelected(button) {
    this.element.querySelectorAll('button[data-color-picker-value-param]').forEach((btn) => {
      const swatch = btn.querySelector("div")
      if (swatch) {
        swatch.classList.remove("ring-2", "ring-offset-2", "ring-blue-500")
      }
    })

    const swatch = button.querySelector("div")
    if (swatch) {
      swatch.classList.add("ring-2", "ring-offset-2", "ring-blue-500")
    }
  }
}
